import React, { Component, Fragment } from 'react';
import {connect} from 'react-redux';
// import moment from 'moment';
import _ from 'lodash';
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";


import {Config} from '../../util';
import LogoUrl from '../../util/LogoUrl';


class ChannelItem extends Component{

  constructor(props){
    super(props);
    this.state = {};

    this.handleContextMenuClick = this.handleContextMenuClick.bind(this);

  }

  handleContextMenuClick(e, data){
    const { 
      channelInfo,
      onContextMenuClick 
    } = this.props;

    const info = Object.assign({}, channelInfo);
    info.data = data.item;

    if(onContextMenuClick) { onContextMenuClick (info)}
  }


  render(){
    const {
      channelInfo,
      channelIndex,
      activeChannelListIndex
    } = this.props;
    const {chname, chid} = channelInfo;

    const htmlId = `channelItem_${chid}`;
    // const imageInfo = LogoUrl(channelInfo.chname);
    const imageInfo = _.keyBy(Config.logoUrl, 'epgId')[channelInfo.epgid];
    const channelClass = 'channel item' + (activeChannelListIndex === channelIndex ? ' active' : '');
    const isMenuItemName = !Config.isPreviewMenuName && Config.logoUrl && Config.logoUrl.length > 0; 


    return (
      <Fragment>
        <ContextMenuTrigger id={htmlId} holdToDisplay={-1} key={htmlId}>
          <div className={channelClass} tabIndex={0}>
            <img src={imageInfo && imageInfo.imgWhite} alt={chname}/>
          </div>
        </ContextMenuTrigger>
        {!Config.liveImgMode &&
          <ContextMenu id={htmlId} className='react-contextmenu-custom' key={`${htmlId}_contextmenu`} >
            <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Popup' }} key='popup'>Popup</MenuItem>
            <MenuItem divider key='divider'/>
            <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Video1' }} key='preview-1'>{isMenuItemName ? Config.logoUrl[0].id : "Preview1"}</MenuItem>
            <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Video2' }} key='preview-2'>{isMenuItemName ? Config.logoUrl[1].id : "Preview2"}</MenuItem>
            <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Video3' }} key='preview-3'>{isMenuItemName ? Config.logoUrl[2].id : "Preview3"}</MenuItem>
            <MenuItem onClick={this.handleContextMenuClick} data={{ item: 'Video4' }} key='preview-4'>{isMenuItemName ? Config.logoUrl[3].id : "Preview4"}</MenuItem>
          </ContextMenu>
        }
      </Fragment>
    );
  }
  
}

const mapStateToProps = state => {
  return {
    activeChannelListIndex: state.activeChannelListIndex
  }
};

ChannelItem = connect(mapStateToProps)(ChannelItem);

export default ChannelItem;


// WEBPACK FOOTER //
// ./src/components/channel/ChannelItem.js